export const TOKEN_STORAGE_KEY = 'api.token';
export const COMPANY_ID_STORAGE_KEY = 'api.company_id';
export const ADMIN_STORAGE_KEY = 'api.role.admin'; //
export const FEATURES_LEVEL_KEY = 'settings.features_level';
export const BRANCH_ID_STORAGE_KEY = 'api.branch_id';
